import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Gift } from "lucide-react";
import { api } from "@/lib/api";

export function MysteryCountdownBadge({ userId, isMe, name }) {
  const [d, setD] = useState(null);
  useEffect(() => { api.get(`/users/${userId}/mystery-countdown`).then(({ data }) => setD(data)).catch(() => setD(null)); }, [userId]);
  if (!d?.active) return null;
  const days = `${d.days_left} ${d.days_left === 1 ? "Tag" : "Tagen"}`;
  return (
    <Link to="/community-unterstuetzen#mystery-box" data-testid="profile-mystery-countdown"
      className="fade-up relative flex items-center gap-4 overflow-hidden rounded-3xl vip-lux p-4 sm:p-5 border border-[#c99a3c]/50 hover:-translate-y-0.5 transition-transform">
      <span className="vip-lux-pattern" aria-hidden />
      <motion.span animate={{ rotate: [0, -8, 8, -5, 5, 0] }} transition={{ duration: 1.1, repeat: Infinity, repeatDelay: 3 }}
        className="relative w-12 h-12 shrink-0 rounded-2xl vip-gold-metal flex items-center justify-center"><Gift className="w-6 h-6" /></motion.span>
      <span className="relative min-w-0">
        <span className="block text-[11px] font-extrabold uppercase tracking-[0.25em] text-[#e6c56f]">Mystery-Box</span>
        <span className="block font-display text-lg font-extrabold vip-gold-title" data-testid="profile-mystery-days">Nächste Mystery-Box in {days}</span>
        <span className="block text-xs text-[#cdb88f]">{isMe ? "Bleib Unterstützer – dann kommt sie zu dir nach Hause." : `${(name || "").split(" ")[0]} bekommt als Projekt Unterstützer jeden Monat eine Überraschung per Post.`}{d.boxes > 0 && ` · schon ${d.boxes} ${d.boxes === 1 ? "Box" : "Boxen"} erhalten`}</span>
      </span>
    </Link>
  );
}
